import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, HostListener, input, signal, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ThemeSwitcherComponent } from '../theme-switcher/theme-switcher.component';

@Component({
    selector: 'app-base-header',
    templateUrl: './base-header.component.html',
    imports: [RouterModule, ThemeSwitcherComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BaseHeaderComponent {
    private elementRef = inject(ElementRef);
    public version = input.required<string>();
    public userName = input<string | null>(null);
    public userInfo = input<string | null>(null);
    public userInitials = input<string | null>(null);
    public isAdmin = input<boolean>(false);

    protected mobileMenuOpen = signal(false);

    @HostListener('document:click', ['$event'])
    public onDocumentClick(event: MouseEvent): void {
        if (this.mobileMenuOpen() && !this.elementRef.nativeElement.contains(event.target)) {
            this.mobileMenuOpen.set(false);
        }
    }

    public toggleMobileMenu(): void {
        this.mobileMenuOpen.update((open) => !open);
    }
}
